/**
 * Session stash for pending SEDR invite room-key seeds before guest signup completes.
 * Keys never leave the browser until wrapped into the vault on claim.
 */
const STASH_KEY = 'shareweb:guestPendingInvites';

export interface PendingGuestInviteSeed {
  inviteId: string;
  roomId: string;
  roomServerToken: string;
  envelopeBlobId: string;
  /** base64url guest wrap key (gw) */
  guestWrapKey: string;
  displayName: string;
  organization: string;
  email: string | null;
  guestRole: string;
  allowCommenting: boolean;
  /** When upgrading from legacy invite TOTP; default true. */
  migrateTotp?: boolean;
}

export function listPendingGuestInviteSeeds(): PendingGuestInviteSeed[] {
  try {
    const raw = sessionStorage.getItem(STASH_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as PendingGuestInviteSeed[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function upsertPendingGuestInviteSeed(seed: PendingGuestInviteSeed): void {
  const list = listPendingGuestInviteSeeds().filter((item) => item.inviteId !== seed.inviteId);
  list.push(seed);
  sessionStorage.setItem(STASH_KEY, JSON.stringify(list));
}

export function removePendingGuestInviteSeed(inviteId: string): void {
  const list = listPendingGuestInviteSeeds().filter((item) => item.inviteId !== inviteId);
  sessionStorage.setItem(STASH_KEY, JSON.stringify(list));
}

export function clearPendingGuestInviteSeeds(): void {
  sessionStorage.removeItem(STASH_KEY);
}
